/**
 * Limpieza de claves locales de borradores del PDFEditor.
 *
 * La recuperación automática de borradores fue retirada.
 * Solo se conservan utilidades para borrar claves identificadas de PDFSigner
 * sin tocar tokens de autenticación ni preferencias ajenas.
 */

export const DRAFT_STORAGE_PREFIX = 'pdfsigner_editor_draft_v2_'
/** Prefijo legado. */
export const DRAFT_STORAGE_PREFIX_LEGACY = 'pdfsigner_editor_draft_v1_'
export const DRAFT_SIGNAL_KEY = 'pdfsigner_editor_draft_signal_v1'

const DRAFT_KEY_PREFIXES = [
  DRAFT_STORAGE_PREFIX,
  DRAFT_STORAGE_PREFIX_LEGACY,
]

function safeStorageRemove(storage, key) {
  try {
    if (storage && typeof storage.removeItem === 'function') {
      storage.removeItem(key)
    }
  } catch {
    /* ignore quota / privacy mode */
  }
}

function listMatchingKeys(storage, prefixes) {
  const keys = []
  if (!storage || typeof storage.length !== 'number') return keys
  try {
    for (let i = 0; i < storage.length; i += 1) {
      const key = storage.key(i)
      if (!key) continue
      if (prefixes.some((p) => key === p || key.startsWith(p))) {
        keys.push(key)
      }
    }
  } catch {
    /* ignore */
  }
  return keys
}

export function draftStorageKey(userId) {
  if (userId == null || userId === '') return null
  return `${DRAFT_STORAGE_PREFIX}${String(userId)}`
}

/** Elimina el borrador de un usuario (session + señal local). */
export function clearEditorDraft(userId) {
  const key = draftStorageKey(userId)
  if (key) {
    safeStorageRemove(typeof sessionStorage !== 'undefined' ? sessionStorage : null, key)
    safeStorageRemove(typeof localStorage !== 'undefined' ? localStorage : null, key)
  }
  // También variantes legacy por usuario
  if (userId != null && userId !== '') {
    const legacy = `${DRAFT_STORAGE_PREFIX_LEGACY}${String(userId)}`
    safeStorageRemove(typeof sessionStorage !== 'undefined' ? sessionStorage : null, legacy)
    safeStorageRemove(typeof localStorage !== 'undefined' ? localStorage : null, legacy)
  }
}

/**
 * Elimina todas las claves de borrador PDFSigner conocidas en sessionStorage
 * y localStorage. No elimina token, user ni otras preferencias.
 */
export function clearAllPdfSignerEditorDrafts() {
  const storages = []
  if (typeof sessionStorage !== 'undefined') storages.push(sessionStorage)
  if (typeof localStorage !== 'undefined') storages.push(localStorage)

  for (const storage of storages) {
    const keys = listMatchingKeys(storage, DRAFT_KEY_PREFIXES)
    keys.forEach((key) => safeStorageRemove(storage, key))
    safeStorageRemove(storage, DRAFT_SIGNAL_KEY)
  }
}

/** Compat: limpia borradores de otros usuarios y el propio al entrar al editor. */
export function clearForeignDrafts(currentUserId) {
  clearAllPdfSignerEditorDrafts()
  if (currentUserId != null) {
    clearEditorDraft(currentUserId)
  }
}
